// extracted by mini-css-extract-plugin
module.exports = {"animationK":"appControl_animationK__OORTI"};